import { render, staticRenderFns } from "./MenuUnderlineButton.vue?vue&type=template&id=04d55d30&"
import script from "./MenuUnderlineButton.vue?vue&type=script&lang=ts&"
export * from "./MenuUnderlineButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports